module.exports = {"id":"dp2_2l3q4","text":"Sharing Through Digital Technologies","instructions":"What is an appropriate action if you encounter misinformation online?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":true,"options":[{"id":"dp2_2l3q4-a1","text":"Report or flag it using platform tools","score":3.7},{"id":"dp2_2l3q4-a2","text":"Share it to increase visibility","score":1.3},{"id":"dp2_2l3q4-a3","text":"Ignore accuracy and repost it","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l3q4.json
// module id = 1019
// module chunks = 41